module.exports = __webpack_public_path__ + "img/logo_2024_white_german.7c9fa00b.svg";